import React, { useState } from "react";
import Login from "../../components/Login";
import background from "../../assets/img/backgroundutama.png";
import backdrop from "../../assets/img/background.png";
import logo1 from "../../assets/img/logo1.png";
import logo from "../../assets/img/logo.png";

function Index() {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <>
      <style>
        {`
        .footer {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 0px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          background: transparent;
          z-index: 9999;
        }

        .footer a {
          color: #fff;
          text-decoration: none;
        }

        /* ======== MOBILE & TABLET RESPONSIVE ======== */
        @media (max-width: 992px) {
          .container {
            flex-direction: column !important;
            width: 95% !important;
            height: auto !important;
            padding: 10px !important;
          }

          .container-login {
            flex-direction: column !important;
            align-items: center !important;
          }

          /* sembunyikan bagian kiri (gambar + teks) */
          .left-section {
            display: none !important;
          }

          .form {
            width: 100% !important;
            justify-content: center !important;
            padding: 10px !important;
          }

          .form-box {
            width: 100% !important;
            max-width: 100% !important;
            padding: 20px !important;
          }

          .logo-jeneponto {
            width: 100px !important;
          }

          .masuk {
            font-size: 24px !important;
            text-align: center !important;
          }

          .form-login-container input {
            font-size: 14px !important;
          }

          .form-login-container button {
            font-size: 14px !important;
          }

          .text-small-mobile {
            font-size: 12px !important;
          }
        }

        /* ======== FORM STYLE ======== */
        .form-login-container {
          text-align: left !important;
        }

        .form-login-container label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 5px;
          color: #000;
        }

        .form-login-container input {
          width: 100%;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
          margin-bottom: 15px;
        }

        .form-login-container button {
          width: 100%;
          background-color: #0c4a85;
          color: white;
          padding: 10px;
          border: none;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
        }

        .form-login-container button:hover {
          background-color: #06366a;
        }
        @media (max-width: 400px) {

  .container {
    width: 95% !important;
  }

  .form {
    width: 100% !important;
    padding: 5px !important;
    justify-content: center !important;
  }

  .form-box {
    width: 100% !important;
    max-width: 330px !important; /* AGAR TIDAK MELEBAR */
    padding: 16px !important;
    margin: 0 auto !important;
  }

  /* Input */
  .form-login-container input {
    width: 100% !important;
    max-width: 100% !important;
    font-size: 13px !important;
  }

  /* Button */
  .form-login-container button {
    width: 100% !important;
    max-width: 100% !important;
    font-size: 14px !important;
  }

  /* Judul Masuk */
  .masuk {
    font-size: 22px !important;
  }

  /* Logo kecil */
  .logo-jeneponto {
    width: 50px !important;
  }
}
@media (max-width: 350px) {

  .container {
    width: 98% !important;
    padding: 0 !important;
  }

  .form {
    width: 100% !important;
    padding: 0px !important;
    justify-content: center !important;
  }

  .form-box {
    width: 100% !important;
    max-width: 280px !important;  /* Sangat penting agar tidak melebar */
    padding: 12px !important;
    margin: 0 auto !important;
    border-radius: 10px !important;
  }

  /* Input */
  .form-login-container input {
    padding: 8px !important;
    font-size: 12px !important;
  }

  /* Password Eye Icon */
  .form-login-container .password-toggle-icon {
    transform: scale(0.8) !important; /* Jika Anda pakai icon mata */
  }

  /* Button */
  .form-login-container button {
    padding: 9px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
  }

  /* Logo */
  .logo-jeneponto {
    width: 45px !important;
  }

  /* Judul Masuk */
  .masuk {
    font-size: 20px !important;
  }

  /* Sub text */
  .text-small-mobile {
    font-size: 11px !important;
  }
}
      `}
      </style>

      <div
        className="col-12 hero-container"
        style={{ minHeight: "100vh", position: "relative" }}
      >
        {/* Background */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.3) 81.78%, rgba(255, 255, 255, 0) 95.16%), url(${background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: -1,
          }}
        ></div>

        <div className="col-12 hero">
          <div
            className="container"
            style={{
              display: "flex",
              flexDirection: "row",
              borderRadius: "15px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
              overflow: "hidden",
              position: "absolute",
              top: "48.5%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              maxWidth: "100%",
              minHeight: "300px",
              backgroundImage: `url(${backdrop})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div
              className="container-login"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* KIRI */}
              <div
                className="left-section"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "12px",
                  maxWidth: "50%",
                  padding: "80px",
                  textAlign: "center",
                }}
              >
                <img
                  src={logo}
                  alt="logo"
                  style={{ width: "150px", height: "auto" }}
                />
                <h3 className="text-white">
                  Selamat Datang Kembali di Sistem Informasi Manajemen SMK
                  Negeri 1 Bawen
                </h3>
                <span className="text-white">
                  “Menjadi SMK Rujukan Nasional Tahun 2025 Dalam Bidang
                  Pertanian dan Pariwisata”
                </span>
              </div>

              {/* KANAN */}
              <div
                className="form"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  padding: "25px",
                }}
              >
                <div
                  className="form-box"
                  style={{
                    width: "500px",
                    maxWidth: "100%",
                    minWidth: "260px",
                    backgroundColor: `rgba(255, 255, 255, 0.5)`,
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={logo1}
                      alt="Logo"
                      className="logo-jeneponto"
                      style={{ width: "60px" }}
                    />
                  </div>

                  <div style={{ textAlign: "justify" }}>
                    <p
                      className="masuk"
                      style={{
                        fontSize: "32px",
                        fontWeight: "bold",
                        color: "#fff",
                        marginBottom: "1px",
                      }}
                    >
                      Masuk
                    </p>
                    <span style={{ fontSize: "14px", color: "#fff" }}>
                      Silakan masuk menggunakan akun anda
                    </span>
                  </div>

                  <div className="form-login-container">
                    <Login />
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <p
                      className="text-small-mobile"
                      style={{ fontSize: "12px", color: "#000" }}
                    >
                      Tidak memiliki akun?
                    </p>
                    <span style={{ fontSize: "12px", color: "#000" }}>
                      Silakan hubungi Sekolah
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MODAL LOGIN */}
        {showLogin && (
          <div
            onClick={() => setShowLogin(false)}
            style={{
              position: "fixed",
              backdropFilter: "blur(4px)",
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{ maxWidth: "500px", width: "100%" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Login />
            </div>
          </div>
        )}
      </div>

      {/* FOOTER */}
      {/* <div className="footer">
        <a
          href="https://halteng.geschool.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Dinas Pendidikan Halmahera Tengah 2025
        </a>
      </div> */}
    </>
  );
}

export default Index;
